module.exports = __webpack_public_path__ + "static/img/bg_mingshi@2x.c014f84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/bg_mingshi@2x.png
// module id = I3dK
// module chunks = 96